export const mapNumberOfMonthsToDays: Record<number, number> = {
  1: 28,
  3: 84,
};
